import { useMediaQuery } from "@material-ui/core";

/**
 * Hook for view-only state: tablet/landscape detection.
 * Selected and target track are owned by trackReducer in TrackLocation (single source of truth).
 *
 * @returns {Object} isTabletOrLandscape, showPlaceAction
 */
export const useTrackLocationView = () => {
  const isTablet = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isTabletOrLandscape = isTablet;
  const showPlaceAction = !isTabletOrLandscape;

  return {
    isTabletOrLandscape,
    showPlaceAction,
  };
};
